<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">使用Remix</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">设置Remix IDE</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">智能合约</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">编译智能合约</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">Running a Validator</a></p>
          </div>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">Delegators</a></p>
          <div class="subAnchor">
            <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">Delegator rewards</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">部署</div>
      <div id="box1" class="p2">使用Remix</div>
      <div class="p3">部署带有消息的 FRC20 智能合约，并将其呈现在前端。您可以轻松地与智能合约进行交互！这个 dapp 实现了一个“Hello World”风格的应用程序，它将传递给合约的消息回显到前端。本教程旨在使用Remix IDE提供的在线 IDE 进行学习。</div>
      <div id="box2" class="p2">设置Remix IDE</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>Remix 是一个用于开发智能合约的在线 IDE。</li>
          <li>您需要选择 Solidity Compiler 和 Deploy and Run Transactions。</li>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/remix-01.png" alt=""></div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>转到文件资源管理器，然后创建一个新文件，将其命名为 MegaCoin.sol</li>
          <li>将下面的智能合约复制/粘贴到新创建的文件 MegaCoin.sol</li>
        </ul>
      </div>
      <div id="box3" class="p2">智能合约</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>在此处创建新合约 FRC20Tokens.sol 并从 FRC20 代币模板复制合约代码</li>
          <li>根据您的要求修改“name”、“symbol”、“decimals”和“totalSupply”。</li>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/remix-02.png" alt=""></div>
      <div class="p3">第一行，指定源代码适用于大于 0.5.16 的 Solidity 版本。Pragma是编译器关于如何处理源代码的常用指令（例如，pragma once）。pragma solidity ^0.5.16</div>
      <div class="p3">Solidity 意义上的合约是位于以太坊区块链上特定地址的代码（其功能）和数据（其状态）的集合。在文档中了解有关构造函数和内存的更多信息。</div>
      <div id="box4" class="p2">编译智能合约</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>Step1：点击按钮切换到编译页面</li>
          <li>Step2：选择“FRC20Tokens”合约</li>
          <li>Step3：勾选“Auto compile”和“Enable optimization”复选框</li>
          <li>Step4：点击“ABI”复制合约abi并保存。</li>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/remix-03.png" alt=""></div>
      <div class="p3">现在，我们必须在 FaxChain 网络上部署我们的智能合约。为此，我们必须连接到 web3 世界，这可以通过我的许多服务来完成，例如 Metamask、Brave、Portis 等。我们将使用 Metamask。请按照本教程设置 Metamask 帐户。</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>打开 Metamask 并从网络下拉列表中选择自定义 RPC</li>
          <li>进入设置页面</li>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/remix-04.png" alt=""></div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>添加新网络</li>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/faxchain.png" alt=""></div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>测试网 * RPC URL * ChainID：778787 * 符号：FAX * 区块浏览器：http://54.177.246.141:19080/</li>
          <li>主网 * RPC URL * ChainID：778777 * 符号：FAX * 区块浏览器：http://faxscan.org/</li>
          <li>继续并单击保存</li>
          <li>从 Metamask 复制您的地址</li>
          <li>前往水龙头并请求测试 FAX</li>
          <li>现在，让我们在 FaxChain 测试网上部署智能合约</li>
          <li>在 Environment 下拉列表和你的合约中选择 Injected Web3</li>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/remix-06.png" alt=""></div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>接受连接请求！</li>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/remix-07.png" alt=""></div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>一旦 Metamask 连接到 Remix，“部署”交易将生成另一个需要交易确认的 metamask 弹出窗口。</li>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/remix-08.png" alt=""></div>
      <div class="p3">已成功部署 FRC20 合约。现在您可以与智能合约进行交互。在此处查看部署状态：http://54.177.246.141:19080/</div>
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">使用Remix</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">设置Remix IDE</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">智能合约</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">编译智能合约</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">Running a Validator</a></p>
      </div>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">Delegators</a></p>
      <div class="subAnchor">
        <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">Delegator rewards</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Staking',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>